export default "__VITE_ASSET__D6f_9QcT__"